import { Box } from '@mui/material';
import { GridPanel, GridPanelProps, useGridApiContext } from '@mui/x-data-grid-pro';
import React from 'react';
import { useFeatureToggles } from '../../feature-toggles';
import { dataGridFilterPanelOkButtonToggle } from './fasit-filter-panel';

export function FasitGridPanel(props: GridPanelProps) {
  const apiRef = useGridApiContext();
  const { isFeatureEnabled } = useFeatureToggles();

  if (!isFeatureEnabled(dataGridFilterPanelOkButtonToggle)) {
    return <GridPanel {...props} placeholder="" onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />;
  }

  function handleBackdropMouseUp() {
    apiRef.current.hidePreferences();
  }

  return (
    <>
      {props.open && (
        <Box data-testid="fasit-grid-panel-backdrop" sx={{ position: 'fixed', inset: 0, zIndex: theme => theme.zIndex.modal }} onMouseUp={handleBackdropMouseUp} />
      )}
      <GridPanel {...props} placeholder="" onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
    </>
  );
}
